var map = {
	"./chat.svg": [
		"9b69",
		"chunk-2d0f00c2"
	],
	"./edit.svg": [
		"daf0",
		"chunk-2d228ebd"
	],
	"./haus.svg": [
		"6a84",
		"chunk-2d0da01d"
	],
	"./home.svg": [
		"ac9d",
		"chunk-2d2133e3"
	],
	"./investments.svg": [
		"2c07",
		"chunk-2d0bd52e"
	],
	"./mail.svg": [
		"3ae9",
		"chunk-2d0c4878"
	],
	"./phone.svg": [
		"c3bb",
		"chunk-2d216d66"
	],
	"./profile.svg": [
		"95dc",
		"chunk-2d0e5d91"
	],
	"./proposals.svg": [
		"82e9",
		"chunk-2d0ddde4"
	],
	"./x.svg": [
		"7387",
		"chunk-2d0d67d1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "153d";
module.exports = webpackAsyncContext;